(function () {
  angular
    .module('MktzapApp.Controllers')
    .requires
    .push();
  angular.module('MktzapApp.Controllers')
    .controller('OpSummaryController', summary)
  summary.$inject = ['$rootScope', 'DashboardService', 'NotificationService', 'ngTableParams', '$state'];
  function summary ($rootScope, DashboardService, NotificationService, ngTableParams, $state) {
    var vmOPCtrl = this;

    vmOPCtrl.filters = {
      fromDate: moment().startOf('month').format('DD/MM/YYYY'),
      toDate: moment().endOf('month').format('DD/MM/YYYY')
    };

    // Dashboard rotation
    if ($state.params.time) {
      var dash;
      if ($state.params.business) {
        dash = 'main.dashboard-business-management';
      } else if ($state.params.team) {
        dash = 'main.dashboard-team-management';
      }

      if ($state.params.from && $state.params.to) {
        vmOPCtrl.filters.fromDate = $state.params.from;
        vmOPCtrl.filters.toDate = $state.params.to;
      }

      setTimeout(function () {
        $state.go(dash, {
          time: $state.params.time,
          business: $state.params.business,
          team: $state.params.team,
          op: $state.params.op,
          from: vmOPCtrl.filters.fromDate,
          to: vmOPCtrl.filters.toDate
        });
        clearInterval(filterInterval);
      }, $state.params.time);
    }

    vmOPCtrl.dateSelected = function (type, date) {
      if (type == 'from') {
        vmOPCtrl.pkadayToDate.setMinDate(date);
      }
      if (type == 'to') {
        vmOPCtrl.pkadayFromDate.setMaxDate(date);
      }
    };

    $rootScope.fullscreen = true;

    DashboardService.loadFiltersBM()
      .$promise
      .then(function (data) {
        vmOPCtrl.sectors = data.sectors;
      })
      .catch(function (error) {
        NotificationService.errorHandler(error, vmOPCtrl.labels.common.errorGetFilters);
      });

    vmOPCtrl.goHome = function () {
      vmOPCtrl.hide = false;
      vmOPCtrl.showdetails = [];
    }

    vmOPCtrl.filterDatas = function () {
      DashboardService.filterOpSummary({
        filters: vmOPCtrl.filters
      })
        .$promise
        .then(function (data) {
          if (data.success === false) {
            NotificationService.warningHandler(data, vmOPCtrl.labels.common.report.errorReport);
            return;
          }
          vmOPCtrl.sessions = data.sessions;
          vmOPCtrl.totals = data.totals;
        })
        .catch(function (error) {
          NotificationService.errorHandler(error, vmOPCtrl.labels.common.errorGetInfo);
        });
    }

    vmOPCtrl.filterDetails = function (type, user) {
      var show = [];
      show[type] = true;
      vmOPCtrl.showdetails = show;
      vmOPCtrl.hide = true;

      var filters = vmOPCtrl.filters;
      filters.type = type;
      filters.user_id = user.user_id;

      DashboardService.filterDetailsOpSummary({
        filters: filters
      })
        .$promise
        .then(function (data) {
          vmOPCtrl.details = data;
          vmOPCtrl.details.name = user.name;
          vmOPCtrl.tableSumParams = new ngTableParams({ count: 30 }, { data: vmOPCtrl.details.header });
          vmOPCtrl.tableRowsParams = new ngTableParams({ count: 50 }, { data: vmOPCtrl.details.rows });
        })
        .catch(function (error) {
          NotificationService.errorHandler(error, vmOPCtrl.labels.common.errorGetInfo);
        });
    }

    vmOPCtrl.filterDatas();
    var filterInterval = setInterval(function () {
      vmOPCtrl.filterDatas();
    }, 60000);

    vmOPCtrl.filterByDay = function () {
      vmOPCtrl.filters = {
        fromDate: moment().format('DD/MM/YYYY'),
        toDate: moment().format('DD/MM/YYYY')
      };
      vmOPCtrl.filterDatas();

      var viewByDay = document.getElementById('viewByDay');
      viewByDay.setAttribute('class', 'active');
      var viewByMonth = document.getElementById('viewByMonth');
      viewByMonth.classList.remove('class', 'active');
    }

    vmOPCtrl.filterByMonth = function () {
      vmOPCtrl.filters = {
        fromDate: moment().startOf('month').format('DD/MM/YYYY'),
        toDate: moment().endOf('month').format('DD/MM/YYYY')
      };
      vmOPCtrl.filterDatas();

      var viewByMonth = document.getElementById('viewByMonth');
      viewByMonth.setAttribute('class', 'active');
      var viewByDay = document.getElementById('viewByDay');
      viewByDay.classList.remove('class', 'active');
    }

    vmOPCtrl.toggleFilters = function () {
      var div = document.getElementById('filters_info');
      if (div.style.display === 'none') {
        div.style.display = 'block';
      } else {
        div.style.display = 'none';
      }
    }
  }
})();
